module.exports = __webpack_public_path__ + "static/media/map.70bbc77c.png";